import React from 'react';

function CookieConsent({ onAccept, onDecline }) {
  return (
    <div className="cookie-consent-banner">
      <p className="cookie-consent-text">
        Ova stranica koristi kolačiće (cookies) isključivo za zaštitu od neželjenih poruka putem Google reCAPTCHA servisa.
      </p>
      <div className="cookie-consent-buttons">
        <button className="btn btn-primary cookie-btn" onClick={onAccept}>
          Prihvati
        </button>
        <button className="btn btn-outline-light cookie-btn" onClick={onDecline}>
          Odbij
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
